import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useOrders } from '../hooks/useOrders';
import { OrdersView } from '../views/OrdersView';

export const OrdersContainer = () => {
  const { t } = useTranslation();

  const {
    orders,
    setRowHref,
    loading,
    limit,
    page,
    rowCount,
    sort,
    brokerTimezoneOffset,
    onSortChange,
    onPaginationChange,
  } = useOrders();

  usePageTitle(t('account.orders.title'));

  return (
    <OrdersView
      brokerTimezoneOffset={brokerTimezoneOffset}
      limit={limit}
      loading={loading}
      orders={orders}
      page={page}
      rowCount={rowCount}
      setRowHref={setRowHref}
      sort={sort}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
